var _defs, _g, _g2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlrqSuitability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    preserveAspectRatio: "xMidYMid meet",
    id: "svg_document",
    style: {
      zoom: 1
    },
    visibility: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg_document_title"
  }, "Untitled.svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg_document_title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "svg_document_defs"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_group"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "",
    id: "g1",
    visibility: "visible"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "86px",
    y: "2px",
    id: "rect1",
    strokeWidth: "1px",
    width: "100px",
    fill: "orange",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "186px",
    y: "2px",
    strokeWidth: "1px",
    id: "rect2",
    width: "50px",
    fill: "limegreen",
    visibility: "visible",
    transform: ""
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "186px",
    y: "102px",
    strokeWidth: "1px",
    width: "50px",
    fill: "orange",
    transform: "",
    id: "rect3",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "286px",
    y: "102px",
    strokeWidth: "1px",
    width: "100px",
    fill: "limegreen",
    transform: "",
    id: "rect4",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "86px",
    y: "102px",
    strokeWidth: "1px",
    width: "100px",
    fill: "orange",
    transform: "",
    id: "rect5",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "186px",
    y: "202px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect6",
    fill: "orange",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "286px",
    y: "252px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect7",
    fill: "orange",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "286px",
    y: "302px",
    strokeWidth: "1px",
    id: "rect8",
    width: "100px",
    fill: "orange",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "386px",
    y: "302px",
    strokeWidth: "1px",
    id: "rect9",
    width: "100px",
    fill: "orange",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "386px",
    y: "202px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect10",
    fill: "limegreen",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "86px",
    y: "202px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect11",
    fill: "red",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "86px",
    id: "rect12",
    strokeWidth: "1px",
    width: "100px",
    y: "302px",
    fill: "red",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "186px",
    y: "302px",
    strokeWidth: "1px",
    width: "50px",
    id: "rect13",
    fill: "red",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "286px",
    y: "2px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect14",
    fill: "limegreen",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "386px",
    y: "2px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect15",
    fill: "limegreen",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "386px",
    y: "102px",
    strokeWidth: "1px",
    width: "100px",
    id: "rect16",
    fill: "limegreen",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "236px",
    y: "2px",
    strokeWidth: "1px",
    width: "50px",
    fill: "limegreen",
    id: "rect17",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "100px",
    x: "236px",
    y: "102px",
    strokeWidth: "1px",
    width: "50px",
    fill: "limegreen",
    id: "rect18",
    transform: "",
    visibility: "visible"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "286px",
    y: "202px",
    strokeWidth: "1px",
    width: "100px",
    fill: "limegreen",
    transform: "",
    visibility: "visible",
    id: "rect19"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "186px",
    y: "52px",
    strokeWidth: "1px",
    width: "50px",
    fill: "orange",
    transform: "",
    visibility: "visible",
    id: "rect20"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "386px",
    y: "252px",
    strokeWidth: "1px",
    width: "50px",
    fill: "orange",
    transform: "",
    visibility: "visible",
    id: "rect21"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "236px",
    y: "302px",
    strokeWidth: "1px",
    width: "50px",
    fill: "orange",
    transform: "",
    visibility: "visible",
    id: "rect22"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "236px",
    y: "352px",
    strokeWidth: "1px",
    width: "50px",
    fill: "red",
    transform: "",
    visibility: "visible",
    id: "rect23"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    height: "50px",
    x: "436px",
    y: "252px",
    strokeWidth: "1px",
    width: "50px",
    fill: "limegreen",
    transform: "",
    visibility: "visible",
    id: "rect24"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "2.5px",
    id: "line1",
    x1: "136px",
    strokeWidth: "1px",
    y2: "403.5px",
    x2: "136px",
    transform: ""
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "2px",
    x1: "236px",
    strokeWidth: "1px",
    y2: "403px",
    x2: "236px",
    transform: "",
    id: "line2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "2.5px",
    x1: "336px",
    strokeWidth: "1px",
    y2: "403.5px",
    x2: "336px",
    transform: "",
    id: "line3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "2.5px",
    x1: "436px",
    strokeWidth: "1px",
    y2: "403.5px",
    x2: "436px",
    transform: "",
    id: "line4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "52.000000px",
    x1: "86.000000px",
    strokeWidth: "1px",
    y2: "52.000000px",
    x2: "485.000000px",
    transform: "",
    id: "line5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "152.000000px",
    x1: "86.000000px",
    strokeWidth: "1px",
    y2: "152.000000px",
    x2: "485.000000px",
    transform: "",
    id: "line6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "252.000000px",
    x1: "86.000000px",
    strokeWidth: "1px",
    y2: "252.000000px",
    x2: "485.000000px",
    transform: "",
    id: "line7"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "352.000000px",
    x1: "86.000000px",
    strokeWidth: "1px",
    y2: "352.000000px",
    x2: "485.000000px",
    transform: "",
    id: "line8"
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text1",
    strokeWidth: "1px",
    x: "284.5px",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "#000000",
    fontSize: "24px",
    y: "468.5px",
    transform: "",
    textAnchor: "middle"
  }, "Access"), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text3",
    strokeWidth: "1px",
    x: "80px",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    fill: "#000000",
    fontSize: "16px",
    y: "415px",
    transform: "",
    textAnchor: "middle"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text2",
    strokeWidth: "1px",
    x: "110px",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    y: "213px",
    fill: "#000000",
    fontSize: "24px",
    transform: "rotate(-90 75 248.859375)",
    textAnchor: "middle"
  }, "Capability"), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "1px",
    x1: "86px",
    strokeWidth: "3px",
    y2: "403px",
    x2: "86px",
    transform: "",
    id: "line11"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "402.000000px",
    x1: "86.000000px",
    strokeWidth: "3px",
    y2: "402.000000px",
    x2: "485.000000px",
    transform: "",
    id: "line12"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "2.5px",
    x1: "484px",
    strokeWidth: "3px",
    y2: "403.5px",
    x2: "484px",
    transform: "",
    id: "line13"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    y1: "2.000000px",
    id: "line14",
    strokeWidth: "3px",
    x1: "85.000000px",
    y2: "2.000000px",
    x2: "485.000000px",
    transform: ""
  })), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text4",
    strokeWidth: "1px",
    x: "286px",
    textRendering: "geometricPrecision",
    fontFamily: "Helvetica",
    y: "416px",
    fill: "#000000",
    fontSize: "16px",
    transform: "",
    textAnchor: "middle"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text5",
    strokeWidth: "1px",
    x: "482px",
    textRendering: "geometricPrecision",
    y: "416px",
    fontFamily: "Helvetica",
    fill: "#000000",
    fontSize: "16px",
    transform: "",
    textAnchor: "middle"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text6",
    strokeWidth: "1px",
    x: "79px",
    textRendering: "geometricPrecision",
    y: "206px",
    fontFamily: "Helvetica",
    fill: "#000000",
    fontSize: "16px",
    transform: "",
    textAnchor: "middle"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    style: {
      outlineStyle: "none"
    },
    id: "text7",
    strokeWidth: "1px",
    x: "79px",
    textRendering: "geometricPrecision",
    y: "12px",
    fontFamily: "Helvetica",
    fill: "#000000",
    fontSize: "16px",
    transform: "",
    textAnchor: "middle"
  }, "8"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlrqSuitability);
export default __webpack_public_path__ + "static/media/dlrq-suitability.50609ea86fd723a983e734f9c54dfaae.svg";
export { ForwardRef as ReactComponent };